import React from 'react';
import { connect } from 'react-redux';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { showTransferRequest } from '../actions';
import { requestTransferTypes } from '../constants';
import { resolveRequestWorkflow } from '../state/state';

const TransferRequestsAction = ({
  category,
  code,
  isAuto,
  showTransfer,
  disabled,
}) => (
  <RibbonMenu
    name="transfer"
    icon={isAuto ? 'exchange' : 'checkmark'}
    message={isAuto ? 'actions.transfer' : 'actions.complete'}
    onClick={() => showTransfer(category, code)}
    disabled={disabled}
    className="aridhia-transfer-action-menu"
  />
);

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(
    requests,
    workflows,
    ownProps,
    { transfer: { transfer_type: requestTransferTypes.CLEAR, ready_for_transfer: false }, waiting: true },
  );

  return {
    isAuto: request.transfer.transfer_type !== requestTransferTypes.MANUAL,
    disabled: !request.transfer.ready_for_transfer || request.waiting,
  };
};

const mapDispatchToProps = {
  showTransfer: showTransferRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(TransferRequestsAction);
